<template>
  <div class="app-activation-success">
    <div class="videoIdentWeb"
    v-if="getSuccessIdent === 'videoIdentWeb'"
    ><dyn-slot :slot-data="{SuccessUrl: getSuccessUrl, linkEnabled: getClassUrl(), msisdn: msisdn }"><slot name="txtVideoIdentWeb">Success VideoIdent {{getSuccessUrl}} {{getClassUrl()}}</slot></dyn-slot></div>
    <div class="videoIdentPost"
         v-if="getSuccessIdent === 'videoIdentPost'"
    ><dyn-slot :slot-data="{SuccessUrl: getSuccessUrl, linkEnabled: getClassUrl(), msisdn: msisdn }"><slot name="txtVideoIdentPost">Success VideoIdent {{getSuccessUrl}} {{getClassUrl()}}</slot></dyn-slot></div>
    <div class="postIdent"
         v-if="getSuccessIdent === 'postIdent'"
    ><dyn-slot :slot-data="{SuccessUrl: getSuccessUrl, linkEnabled: getClassUrl(), msisdn: msisdn }"><slot name="txtPostIdent">Success PostIdent {{getSuccessUrl}} {{getClassUrl()}}</slot></dyn-slot></div>
  </div>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import { stepName as prevProcessStep } from '../Wrapper/ActivationAutoTopUpAndPayment.vue'
import { mapGetters, mapMutations } from 'vuex'
import DynSlot from '../../../../generic/DynSlot.vue'

export const stepName = 'success'

export default {
  name: 'Success',
  components: {
    DynSlot
  },
  mixins: [
    processSteps(stepName, prevProcessStep, stepName)
  ],
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    getClassUrl () {
      if (this.getSuccessUrl !== null) {
        return 'link-set'
      }
      return 'link-unset'
    },
    back () {
      this.goToStep(this.previousStep)
    }
  },
  computed: {
    ...mapGetters('activation/submit', [
      'getSuccessIdent',
      'getSuccessUrl'
    ]),
    ...mapGetters('activation/info', [
      'msisdn'
    ])
  }
}
</script>
